import { render, staticRenderFns } from "./CarCancelled.vue?vue&type=template&id=33480686&"
import script from "./CarCancelled.vue?vue&type=script&lang=js&"
export * from "./CarCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports